export const config = {
  id: 'oregonTier2',
  path: '/oregon-tier-2',
  show: () => true,
};
